'use client'
import Link from 'next/link'
import { useEffect, useState } from 'react'

import { linkUrl } from '@/lib/link'

import styles from './Searchnavigation.module.css'

export interface LinkProps {
  id: string
  url: string
  linktype: string
  fieldtype: string
  cached_url: string
}

export interface SearchNavigationProps {
  blok: {
    links: any
  }
}

export const PhnxSearchNavigation: React.FC<SearchNavigationProps> = ({ blok }) => {
  const [activeTab, setActiveTab] = useState('')

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setActiveTab(window.location.pathname)
    }
  }, [])

  // get url

  return (
    <div className={styles['searchNavigation']}>
      <div className={styles['container']}>
        <div className={styles['tabs']}>
          <div className={styles['tabs-items']}>
            {blok.links.map((link: any) => {
              return (
                <Link
                  key={link._uid}
                  className={`${styles[activeTab === linkUrl(link.link) ? 'tabs-item-active' : 'tabs-item']}`}
                  data-isactive={activeTab}
                  href={`${linkUrl(link.link)}`}
                  passHref
                >
                  {link.label}
                </Link>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
